import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./AuthSlice";
import  routeReducer from './RouteSlice'
export const store = configureStore({
  reducer: {
    auth: authReducer,
    routes: routeReducer,
  },
});
